module.exports = __webpack_public_path__ + "img/game.4aee8d75.png";